import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import WikiPage from "./pages/WikiPage";
import NewsPage from "./pages/NewsPage";
import DownloadsPage from "./pages/DownloadsPage";
import RankingsPage from "./pages/RankingsPage";
import LoginPage from "./pages/LoginPage";
import AccountPanel from "./pages/AccountPanel";
import DonatePage from "./pages/DonatePage";
import LegalPage from "./pages/LegalPage";
import AdminLayout from "./components/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminSearch from "./pages/admin/AdminSearch";
import AdminPlayer from "./pages/admin/AdminPlayer";
import AdminAudit from "./pages/admin/AdminAudit";
import AdminClaims from "./pages/admin/AdminClaims";
import AdminContent from "./pages/admin/AdminContent";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { ContentProvider } from "./context/ContentContext";
import ThemeApplicator from "./components/ThemeApplicator";
import SiteHead from "./components/SiteHead";
import FloatingVoteBanners from "./components/FloatingVoteBanners";

function App() {
  return (
    <div className="App min-h-screen bg-bg">
      <BrowserRouter>
        <AuthProvider>
          <ContentProvider>
            <ThemeApplicator />
            <SiteHead />
            <FloatingVoteBanners />
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/wiki" element={<WikiPage />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/downloads" element={<DownloadsPage />} />
              <Route path="/rankings" element={<RankingsPage />} />
              <Route path="/account" element={<LoginPage />} />
              <Route path="/account/panel" element={<AccountPanel />} />
              <Route path="/account/donate" element={<DonatePage />} />
              <Route path="/p/:slug" element={<LegalPage />} />

              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="search" element={<AdminSearch />} />
                <Route path="player/:account" element={<AdminPlayer />} />
                <Route path="audit" element={<AdminAudit />} />
                <Route path="claims" element={<AdminClaims />} />
                <Route path="content" element={<AdminContent />} />
              </Route>
            </Routes>
            <Footer />
            <Toaster theme="dark" position="top-right" />
          </ContentProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
